export const PUBLIC_IMG_PATH = `${process.env.PUBLIC_URL}/images`